import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { heightPercentageToDP } from 'utils/responsiveness';

import { RIBBON_CONTAINER_PADDING } from 'components/Ribbon/styles';

const styles = StyleSheet.create({
    root: {
        flexDirection: 'row',
        marginTop: heightPercentageToDP(20, 16, 20),
        paddingHorizontal: RIBBON_CONTAINER_PADDING,
    },
    card: {
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
    cardTitleContainer: {
        backgroundColor: COLOR.BLACK,
    },
});

export default styles;
